{
  "upload": {
    "absent": {
      "text": "Sie haben keine aktive Lizenz."
    },
    "text": "Lizenzdatei hochladen",
    "title": "Klicken Sie hier, um eine Lizenzdatei auszuwählen und hochzuladen",
    "dropInformation": "Legen Sie die Lizenz hier ab oder klicken Sie hier, um die Auswahl zu starten",
    "validation": {
      "fileMandatory": "Die Datei muss eine .JWT oder .OPL sein",
      "fileEmpty": "Die Datei darf nicht leer sein",
      "fileSize": "Die Datei darf höchstens 750 MB groß sein"
    },
    "new": {
      "text": "Laden Sie eine neue Lizenzdatei hoch",
      "title": "Klicken Sie hier, um eine neue Lizenzdatei auszuwählen und hochzuladen"
    },
    "loading": "Wird geladen...",
    "success": "Gültige Lizenz",
    "errors": {
      "signature_invalid": "Es wurde ein Signierungsfehler mit der Lizenzdatei erkannt.",
      "license_id_already_exists": "Die Lizenzkennung ist mit der aktuellen Lizenz identisch.",
      "platform_id_not_match": "Die Plattformkennung stimmt nicht überein.",
      "organization_id_not_match": "Die Organisationskennung stimmt nicht überein.",
      "expires_contracted_invalid": "Das Ablaufdatum liegt vor dem aktuellen Datum.",
      "expires_tolerate_invalid": "Das Ablaufdatum stimmt nicht mit dem erwarteten Wert überein.",
      "max_devices_total_value_invalid": "Die Gesamtzahl der Geräte stimmt nicht mit dem erwarteten Wert überein.",
      "max_devices_total_contracted_expires_invalid": "Die Anzahl der Geräte ist niedriger als der aktuelle Wert für die Organisation.",
      "max_devices_total_tolerated_expires_invalid": "Die Gesamtzahl der Geräte stimmt nicht mit dem erwarteten Wert überein.",
      "max_devices_by_type_value_invalid": "Die Gesamtzahl der Geräte stimmt nicht mit dem erwarteten Wert überein.",
      "max_devices_by_type_contracted_expires_invalid": "Die Anzahl der Geräte ist niedriger als der aktuelle Wert für die Organisation.",
      "max_devices_by_type_tolerated_expires_invalid": "Die Gesamtzahl der Geräte stimmt nicht mit dem erwarteten Wert überein.",
      "feature_value_invalid": "Die Lizenzfunktionen stimmen nicht mit dem erwarteten Wert überein.",
      "schema_not_match": "Es wurde ein Formatfehler in der Lizenzdatei bezüglich der folgenden Informationen festgestellt: {field}"
    }
  },
  "status": {
    "title": "Lizenzstatus",
    "active": "Aktiv",
    "notActive": "Stand-by",
    "warning": "Warnung",
    "expired": "Abgelaufen"
  },
  "characteristics": {
    "title": "Eigenschaften",
    "date": {
      "validated": "Validierungsdatum:",
      "validatedOn": "Validiert am {date}",
      "start": "Startdatum:",
      "end": "Ablaufdatum:"
    },
    "id": "Lizenz-ID:"
  },
  "idCard": {
    "title": "Informationen, die für den Erhalt einer Lizenz benötigt werden",
    "description": "Diese Kennungen sind nützlich für die Generierung der Lizenzen.",
    "export": {
      "title": "ID-Karte exportieren",
      "text": "ID-Karte exportieren"
    },
    "download": "ID-Karte herunterladen"
  },
  "overlay": {
    "title": {
      "notFound": "Ihre Organisation benötigt eine Lizenz",
      "expired": "Ihre Lizenz ist abgelaufen"
    },
    "message": {
      "notFound": "Um Ihre Organisation zu betreiben, laden Sie bitte eine Lizenz hoch. Der Zugriff wird blockiert, bis eine gültige Lizenz hochgeladen ist.",
      "expired": "Um den Betrieb Ihrer Organisation fortzusetzen, erneuern Sie bitte Ihre Lizenz. Der Zugriff ist vorübergehend gesperrt, bis die Situation gelöst ist."
    }
  },
  "gauge": {
    "device": {
      "warning": {
        "tooltip": "Sie haben die Anzahl der von Ihrer Lizenz autorisierten Geräte erreicht",
        "message": "Schwellenwert erreicht"
      },
      "error": {
        "tooltip": "Es kann kein weiteres Gerät auf der Plattform bereitgestellt werden",
        "message": "Limit erreicht"
      }
    }
  },
  "deviceTypes": {
    "title": "Geräte-Schwellenwerte"
  },
  "withoutLimits": "Ohne Begrenzung",
  "total": "Gesamt",
  "features": {
    "title": "Lizenzbeschränkungen",
    "interfaces_third_party": "Schnittstellen",
    "warning": {
      "tooltip": "Sie haben Ihr Lizenzlimit überschritten"
    },
    "error": {
      "tooltip": "Die Erstellung neuer Ressourcen ist deaktiviert"
    }
  },
  "warning": {
    "title": "Lizenzgrenze erreicht.",
    "expirationDateExceeded": "Sie haben das Ablaufdatum Ihrer Lizenz überschritten. Bitte erneuern Sie Ihre Lizenz vor der Dienstunterbrechung.",
    "devicesCountExceeded": "Sie haben mit Ihrer aktuellen Lizenz die zulässige Anzahl von Geräten überschritten. Einige Funktionen sind möglicherweise eingeschränkt, bis das Problem behoben ist.",
    "redirect": "Lizenzbereich anzeigen"
  }
}
